import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./loyalty_in_menu_mode.js";
//#region src/loyalty_in_menu_mode_helper.ts
var loyalty_in_menu_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(loyaltyInMenuMode) {
	switch (loyaltyInMenuMode) {
		case "off": return "Off";
		case "show-log-in-button": return "Show Log In Button";
		case "prompt-to-log-in-at-the-beginning": return "Prompt to Log In at the Beginning";
		case "prompt-to-log-in-at-the-beginning-with-login-options": return "Prompt to Log In at the Beginning with Login Options";
		case "prompt-to-log-in-at-the-beginning-with-login-options-popup": return "Prompt to Log In at the Beginning with Login Options Popup";
	}
}
//#endregion
export { loyalty_in_menu_mode_helper_exports, name };

//# sourceMappingURL=loyalty_in_menu_mode_helper.js.map